import React, { useState, useEffect } from "react";
import ReactTable from "../../components/constantComponent/reactTable/ReactTable";
import { ApiKey, ApiUrl, LanguageKey } from "../../util/Constant";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { fetch } from "whatwg-fetch";

/// <summary>
/// Author : -
/// </summary>

const UserIpPanel = (props) => {
  const [userIpDetail, setUserIpDetail] = useState([]);
  const { t } = useTranslation(LanguageKey._PRIMARY);
  /// <summary>
  /// Author : -
  /// </summary>
  useEffect(() => {
    init();
  }, []);

  /// <summary>
  /// Author : -
  /// </summary>
  const init = async () => {
    if (props.data) {
      let apiUrl = ApiUrl._API_GET_USER_IP_DETAIL;
      apiUrl +=
        "?startDate=" +
        props.data.startDate +
        "&endDate=" +
        props.data.endDate +
        "&username=" +
        props.data.username +
        "&country=" +
        props.data.country +
        "&ipAddress=" +
        props.data.ipAddress +
        "&userType=" +
        props.data.userType;

      await fetch(apiUrl, {
        method: ApiKey._API_GET,
        headers: {
          "Content-Type": ApiKey._API_APPLICATION_JSON,
          "X-Requested-With": ApiKey._API_XML_HTTP_REQUEST_KEY,
        },
      })
        .then((response) => response.json())
        .then((responseJson) => {
          if (responseJson[ApiKey._API_SUCCESS_KEY]) {
            setUserIpDetail(responseJson[ApiKey._API_DATA_KEY]);
          }
        });
    }
  };

  let _IPUserDetailColumns = [
    {
      Header: t("USER_TYPE"),
      accessor: "userType",
    },
    {
      Header: t("USERNAME"),
      accessor: "username",
    },
    {
      Header: t("DATE"),
      accessor: "date",
      Cell: ({ row }) => {
        return <>{moment(row.original.date).format("YYYY-MM-DD HH:mm:ss")}</>;
      },
    },
    {
      Header: t("IP_ADDRESS"),
      accessor: "ipAddress",
    },
    {
      Header: t("COUNTRY"),
      accessor: "country",
    },
    {
      Header: t("USER_AGENT"),
      accessor: "userAgent",
    },
    {
      Header: t("REFERER"),
      accessor: "referer",
    },
  ];

  return (
    <div>
      <ReactTable data={userIpDetail} columns={_IPUserDetailColumns} />
    </div>
  );
};

export default UserIpPanel;
